module.exports = __webpack_public_path__ + "img/group.e594d783.svg";